import type { FilterOption } from '@/components/FilterMenu'
import { FilterMenu } from '@/components/FilterMenu'
import { useTranslation } from 'react-i18next'

interface HiveStateFilterProps {
  options: FilterOption[]
  selectedOption: FilterOption | null
  onChange: (option: FilterOption | null) => void
}

export function HiveStateFilter({
  options,
  selectedOption,
  onChange,
}: HiveStateFilterProps) {
  const { t } = useTranslation()

  return (
    <FilterMenu
      buttonLabel={t('clusterConfigTable.filters.hiveState')}
      options={options}
      selectedOption={selectedOption}
      onOptionChange={onChange}
      isSearchable
      data-testid="hive-state-filter"
    />
  )
}
